/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbPatientRequestSummary } from './HchbPatientRequestSummary';
import {
    HchbPatientRequestSummaryFromJSON,
    HchbPatientRequestSummaryFromJSONTyped,
    HchbPatientRequestSummaryToJSON,
    HchbPatientRequestSummaryToJSONTyped,
} from './HchbPatientRequestSummary';

/**
 * 
 * @export
 * @interface HchbPatientRequestList
 */
export interface HchbPatientRequestList {
    /**
     * 
     */
    data: Array<HchbPatientRequestSummary>;
}

/**
 * Check if a given object implements the HchbPatientRequestList interface.
 */
export function instanceOfHchbPatientRequestList(value: object): value is HchbPatientRequestList {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function HchbPatientRequestListFromJSON(json: any): HchbPatientRequestList {
    return HchbPatientRequestListFromJSONTyped(json, false);
}

export function HchbPatientRequestListFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPatientRequestList {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(HchbPatientRequestSummaryFromJSON)),
    };
}

export function HchbPatientRequestListToJSON(json: any): HchbPatientRequestList {
    return HchbPatientRequestListToJSONTyped(json, false);
}

export function HchbPatientRequestListToJSONTyped(value?: HchbPatientRequestList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(HchbPatientRequestSummaryToJSON)),
    };
}

